export const fetchDataInterceptor = async (url, options) => {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  const res = await fetch(url, { ...options, headers, mode: 'cors' });

  let data;
  try {
    data = await res.json();
  } catch (error) {}

  if (!res.ok) {
    throw new Error(data.message ?? 'Failed', { cause: res });
  }

  return data;
};
